import React, { useLayoutEffect, useState } from 'react';
import { useUser } from 'components/hooks';
import { Alert } from 'components/common';
import { getToken } from 'utils';
// import jwt from "jwt-simple";


export default function AuthProvider ({ children }) {
  const { signOut, auth } = useUser();
  const [expiredToken, setExpiredToken] = useState(false);

  useLayoutEffect(() => {
    auth();
    // let refTimeout;

    const handlerStorage = () => {
			const token = getToken();
			if (token) {
        // const decoded = jwt.decode(token);
        // const expirationDate = decoded.exp;
        // const dateNowSeconds = Date.now() / 1000;
        //
        // const timeLeft = (expirationDate - dateNowSeconds) - 300;
        //
        // if(Math.floor(timeLeft) > 0) {
        //   refTimeout = setTimeout(() => {
        //     signOut();
        //     setExpiredToken(true);
        //   }, timeLeft * 1000);
        // } else {
        //   if(refTimeout) clearTimeout(refTimeout);
        //   signOut();
        // }
      } else {
        //signOut();
      }
		};

    handlerStorage();
    window.addEventListener("storage", handlerStorage);

    return () => window.removeEventListener("storage", handlerStorage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

  return(
    <div>
      <>{children}</>
      { /* success.auth &&
        <Alert
          severity="success"
          handleClose={() => cleanUpMessage()}
          open={true}
          message={'login.alert.success'}
        />*/
      }
      { (expiredToken) &&
        <Alert
          severity="warning"
          open={expiredToken}
          message="token expired"
          handleClose={() => { setExpiredToken(false) }}
        />
      }
    </div>
  );
}
